/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DnR API
 * 地方自治体事業管理システムAPI
 * OpenAPI spec version: 1.0.0
 */

/**
 * EUC取り込み状態
 */
export type EucImportStatus = (typeof EucImportStatus)[keyof typeof EucImportStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EucImportStatus = {
  draft: 'draft',
  processing: 'processing',
  success: 'success',
  failed: 'failed',
} as const;
